"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
/**
 * conditionally render the singular or plural of a noun
 *
 * @param singularForm - of word
 * @param pluralForm - of word
 * @param count
 * @param includeCount - whether to prepend the count
 * @returns either the singular or plural noun
 * @example
 * pluralize('product', 'products', 1, false) => '1 product'
 * pluralize('product', 'products', 4) => '4 products'
 * pluralize('product', 'products', 4, false) => 'products'
 */
var pluralize = function pluralize(singularForm, pluralForm, count) {
  var includeCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var isSingular = count === 1 || count === -1;
  var form = isSingular ? singularForm : pluralForm;
  return includeCount ? "".concat(count, " ").concat(form) : form;
};
var _default = exports.default = pluralize;